export function temRecurso(login, permission) {
  if (!permission) return true;

  let payload = {};
  try {
    if (login?.token) {
      payload = JSON.parse(window.atob(login.token.split('.')[1]));
    }
  } catch (e) {
    payload = {};
  }

  const candidates = [
    payload.permissions,
    payload.permissoes,
    payload.recursos,
    login?.usuario?.demais_dados?.recursos,
  ].filter(Boolean);

  return candidates.some((arr) => Array.isArray(arr) && arr.some((item) => {
    if (typeof item === 'string') {
      const base = item.split('.')[0];
      return base === permission || item === permission;
    }
    if (item && typeof item === 'object') {
      const v = item.nome || item.name || item.id || item.tipo;
      return v === permission;
    }
    return item === permission;
  }));
}

export function podeVerJuridico(login) {
  return Boolean(
    login?.usuario?.demais_dados?.dados_sas?.unidadeId
    && temRecurso(login, 'juridico'),
  );
}
